import GenericErrorPage from './GenericErrorPage.tsx'
import { NavLink } from 'react-router'

export default function ErrorClubNotFound() {
  return (
    <GenericErrorPage
      title="Club Not Found"
      description="We can't find an existing club with this id. Please choose a club from the available clubs."
      children={
        <NavLink
          to="/clubs"
          className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
          See available clubs
        </NavLink>
      }
    />
  )
}
